import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import CustomStep from 'workOrderComponents/close/CustomStep';

class CloseCommentStep extends React.Component {

    constructor(props) {
        super(props);
        this.handleCommentChange = this
            .handleCommentChange
            .bind(this);
    }

    handleCommentChange(e) {

        const {workOrderActions, user, orderId} = this.props;

        workOrderActions.closeCommentSet({
            comment: e.target.value,
            username: user.get('userId')
        }, orderId);

    }

    prepareCommentForLabel(comment) {
        if (comment && comment.length > 100) {
            return comment.substring(0, 97) + '...';
        }
        return comment;
    }

    render() {
        const {orderCloseDetails, workOrderActions, stepConfig, orderId, disabled} = this.props;
        const currentComment = orderCloseDetails.getIn(['closeOrderRequest', 'commentRequest', 'comment']);
        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Comments ${currentComment
                ? '-'
                : ''} ${this.prepareCommentForLabel(currentComment) || ''}`}
                stepConfig={stepConfig}
                stepConfigKey="commentStepConfig"
                orderCloseDetails={orderCloseDetails}
                orderId={orderId}
                activeStep={activeStep}
                stepValidation={stepValidation}
                stepKey="comment">
                <TextField
                    fullWidth
                    disabled={disabled}
                    value={currentComment ? currentComment : ''}
                    floatingLabelText="Enter Close Comments"
                    multiLine={true}
                    onChange={this.handleCommentChange}
                    rows={2}
                    rowsMax={5}/>

            </CustomStep>

        );

    }
}

CloseCommentStep.propTypes = {
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
    user: PropTypes.object,
    stepConfig: PropTypes.object,
    disabled: PropTypes.bool
};

export default CloseCommentStep;


// WEBPACK FOOTER //
// ./src/components/comment/CloseCommentStep.js